var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2469 3.29484C22.0034 3.29397 23.6883 4.02744 24.9313 5.33399C26.1742 6.64054 26.8733 8.41321 26.875 10.2623C26.875 12.9334 25.775 17.1376 20.5437 21.9963C18.8211 23.5771 16.9656 24.9898 15 26.2169C13.0377 24.9893 11.1853 23.5766 9.46563 21.9963C4.23438 17.1376 3.125 12.9334 3.125 10.2623C3.12394 9.01126 3.44286 7.78303 4.04829 6.70653C4.65371 5.63004 5.52329 4.74499 6.56574 4.14432C7.60819 3.54365 8.78504 3.24951 9.97273 3.29279C11.1604 3.33607 12.3151 3.71517 13.3156 4.39029L15 5.5285L16.6844 4.39029C17.7479 3.67395 18.9843 3.29377 20.2469 3.29484ZM20.2469 0.00521882C18.3871 0.00370559 16.566 0.564316 15 1.62042C13.5273 0.627242 11.8279 0.0696329 10.0799 0.00610854C8.33201 -0.0574158 6.60006 0.375487 5.06584 1.25939C3.53161 2.14329 2.25167 3.44561 1.36033 5.02967C0.46899 6.61374 -0.000888372 8.42116 1.26093e-06 10.2623C1.26093e-06 22.1049 15 30 15 30C15 30 30 22.1049 30 10.2623C30 8.91446 29.7477 7.57987 29.2574 6.33478C28.7671 5.0897 28.0486 3.95853 27.1428 3.00595C26.237 2.05336 25.1618 1.29804 23.9785 0.783156C22.7953 0.268271 21.5272 0.00392202 20.2469 0.00521882Z",
    fill: "#BD6600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.eefbdccab62859fb65c16f6f97b29f70.svg";
export { ForwardRef as ReactComponent };